export class AssertionError extends Error {}

export function assert<TCondition>(condition: TCondition, message?: string): asserts condition {
  if (!condition) {
    throw new AssertionError(message);
  }
}
